module.exports = __webpack_public_path__ + "img/twitter.a4444ef.svg";